<script setup>
import moment from 'moment'

const props = defineProps({
  data: Array,
  contestants: Array,
})

const route = useRoute()

// console.log('route is', route.params.contestant)

function getName(nameId) {
  const { contestants } = props
  return contestants.filter(x => x.name_id === nameId)[0].name
}
</script>

<template>
  <div>
    <div class="-mb-2 sm:mb-0 sm:pb-2 sm:hidden block bg-green-100 dark:bg-gray-800">
      <div class="-my-2 overflow-x-auto lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden">
            <table class="">
              <thead class="sg-medium text-md flex">
                <tr class="">
                  <th
                    class="text-center text-white uppercase tracking-wider w-30"
                    scope="col"
                  >
                    <span class="bg-gray-600 px-3">date</span>
                  </th>
                  <th
                    class="text-center text-white uppercase tracking-wider"
                    scope="col"
                  >
                    <span class="bg-gray-600 px-3">title</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 text-gray-600 dark:text-gray-50">
                <tr
                  v-for="show in data"
                  :key="show"
                  class="&hover:bg-green-500 &hover:text-white text-sm flex w-screen"
                >
                  <td
                    class="py-1 whitespace-nowrap text-sm sg-regular uppercase align-top pl-1 min-w-22 flex"
                  >
                    {{ show.date }}
                  </td>
                  <td class="py-1 sg-semibold uppercase align-top pl-5 w-full">
                    <NuxtLink prefetch class="" :to="`/shows/watch/${moment(show.date, 'DD/MM/YYYY').locale('en-ie').format('YYYY')}__${show.yt_link.substring(show.yt_link.indexOf('=') + 1)}`">
                      <span
                        v-if="show.winner_id === route.params.contestant?.toUpperCase()"
                        class="absolute -rotate-20"
                      >
                        <div class="i-fxemoji-trophy text-base relative -left-5 -top-1.5 animate-pulse animate-bounce-in-down" />
                      </span>
                      <span>
                        {{ show.yt_title }}
                      </span>
                    </NuxtLink>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-green-100 dark:bg-gray-800 -mb-2 sm:mb-0 sm:pb-2 hidden sm:block">
      <div class="-my-2 overflow-x-auto lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden">
            <table class="w-full">
              <thead class="sg-medium text-md h-10">
                <tr class="">
                  <th
                    class="py-1 text-center text-white uppercase tracking-wider"
                    scope="col"
                  >
                    <span class="bg-gray-600 px-3">date</span>
                  </th>
                  <th
                    class="text-center text-white uppercase tracking-wider"
                    scope="col"
                  >
                    <span class="bg-gray-600 px-3">title</span>
                  </th>
                  <th
                    class="text-white uppercase tracking-wider text-center items-center"
                    nowrap=""
                    scope="col"
                  >
                    <span class="bg-gray-600 px-3">quiz master</span>
                  </th>
                  <th
                    class="text-center text-white uppercase tracking-wider items-center"
                    scope="col"
                  >
                    <span class="bg-gray-600 px-3">contestants</span>
                  </th>
                  <th
                    class="text-white uppercase tracking-wider text-center"
                    scope="col"
                  >
                    <span class="bg-gray-600 px-3">winner</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 text-gray-600 dark:text-gray-50 dark:divide-green-800">
                <tr
                  v-for="show in data"
                  :key="show"
                  class="&hover:bg-green-500 &hover:text-white text-sm"
                >
                  <td
                    class="py-1 whitespace-nowrap text-center text-sm sg-bold uppercase align-top w-35"
                  >
                    {{ show.date }}
                  </td>
                  <td class="py-1 sg-bold uppercase align-top show">
                    <NuxtLink
                      prefetch
                      :to="`/shows/watch/${moment(show.date, 'DD/MM/YYYY').locale('en-ie').format('YYYY')}__${show.yt_link.substring(show.yt_link.indexOf('=') + 1)}`"
                      class="wavy-text-title"
                    >
                      {{ show.yt_title }}
                    </NuxtLink>
                  </td>
                  <td
                    class="py-1 whitespace-nowrap text-center text-sm sg-bold uppercase align-top w-35"
                  >
                    {{ getName(show.presenter_id) }}
                  </td>
                  <td
                    class="py-1 text-left text-sm sg-bold uppercase align-top w-50"
                  >
                    <span
                      v-for="(contestant, index) in show.contestants"
                      :key="index"
                    >
                      <NuxtLink
                        prefetch
                        :to="`/champ/${contestant.name_id.toLowerCase()}`"
                        class="wavy-text"
                      >
                        {{ getName(contestant.name_id) }}{{ index < show.contestants.length - 1 ? ", " : "" }}
                      </NuxtLink>
                    </span>
                  </td>
                  <td
                    class="py-1 whitespace-nowrap text-center text-sm sg-bold uppercase align-top px-4"
                  >
                    <NuxtLink
                      prefetch
                      :to="`/champ/${show?.winner_id.toLowerCase()}`"
                      class="wavy-text"
                    >
                      {{ getName(show.winner_id) }}
                    </NuxtLink>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.wavy-text:hover {
  text-decoration-line: underline;
  text-decoration-style: wavy;
  text-decoration-color: #ec1d23;
  text-decoration-thickness: 0.08rem;
}

.wavy-text-title:hover {
  text-decoration-line: underline;
  text-decoration-style: wavy;
  text-decoration-color: rgba(59, 130, 246);
  text-decoration-thickness: 0.08rem;
}

.show:hover,
.show:focus,
.show:active {
  view-transition-name: show-name;
}
</style>
